import URLPattern from 'url-pattern';
import { ONE_HOUR_IN_SECONDS } from './common';
import { CacheConfig, CacheStoreConfig } from '@app/types/cache';
import { API_CACHE_STORE_NAME, CACHE_DB_NAME } from './indexed-db';

export const CACHE_STORES: Record<string, CacheStoreConfig> = {
  api: { dbName: CACHE_DB_NAME, storeName: API_CACHE_STORE_NAME },
};

export const CACHE_API_CONFIGS: Array<CacheConfig> = [
  {
    url: new URLPattern('/rental-protection-plans'),
    ttlSeconds: ONE_HOUR_IN_SECONDS,
  },
  {
    url: new URLPattern('/shared/shifts.json'),
    ttlSeconds: ONE_HOUR_IN_SECONDS,
  },
];
